import { JobWizardTabs } from "./JobWizardTabs";
import { JobLibraryService, SavedJobDescription as LibrarySavedJob } from "@/services/jobLibraryService";

interface JobWizardProps {
  onClose: () => void;
  onSave: (jobDescription: LibrarySavedJob) => void;
}

export function JobWizard({ onClose, onSave }: JobWizardProps) {
  return <JobWizardTabs onClose={onClose} onSave={onSave} />;
}